module.exports = __webpack_public_path__ + "static/media/timeline-icon-active.8120d284.svg";